import { CookiePreferences, CookieScreen } from 'common-tracking';
import { FC, useState } from 'react';

import { DetailedCookieBanner } from './detailed-cookie-banner';
import { DetailedCookiePreferenceBanner } from './detailed-cookie-preference-banner';

type Props = {
  allowAll: () => void;
  savePreferences: (preferences: CookiePreferences) => void;
};
export const GetUserConsentDialog: FC<Props> = ({
  allowAll,
  savePreferences,
}) => {
  const [screen, goToScreen] = useState<CookieScreen>('cookie');
  switch (screen) {
    case 'cookie':
      return (
        <DetailedCookieBanner allowAll={allowAll} goToScreen={goToScreen} />
      );
    case 'cookie-preference':
      return (
        <DetailedCookiePreferenceBanner
          savePreferences={savePreferences}
          allowAll={allowAll}
        />
      );
  }
};
